module.exports = __webpack_public_path__ + "static/media/1_Pokana 25_09_2015.89296f47.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2015/1_Pokana 25_09_2015.pdf
// module id = 177
// module chunks = 0